import React, { useEffect, useState } from 'react';

import { acknowledgeDeployUpdateAndReload } from '../utils/deployUpdate';

/**
 * Listens for deploy mismatch (set from auth.fetchUser after user-config). Prompts refresh.
 */
const DeployUpdatePrompt = () => {
  const [pendingCommit, setPendingCommit] = useState(null);

  useEffect(() => {
    const onDeployUpdate = (e) => {
      const commit = e.detail?.commit;
      if (commit) {
        setPendingCommit(commit);
      }
    };
    window.addEventListener('moonscroll:deploy-update', onDeployUpdate);
    return () => window.removeEventListener('moonscroll:deploy-update', onDeployUpdate);
  }, []);

  if (!pendingCommit) {
    return null;
  }

  return (
    <div
      className="fixed bottom-4 right-4 z-[60] w-max max-w-[min(280px,calc(100vw-2rem))] rounded-lg border border-theme-secondary bg-theme-secondary p-3 shadow-2xl"
      role="dialog"
      aria-labelledby="deploy-update-title"
      aria-describedby="deploy-update-desc"
    >
      <p id="deploy-update-title" className="text-sm font-semibold text-theme-text">
        Update available
      </p>
      <p id="deploy-update-desc" className="mt-1.5 text-xs leading-snug text-theme-text opacity-75">
        Reload to use the latest version of the app.
      </p>
      <button
        type="button"
        className="mt-3 inline-flex rounded-md border border-theme-primary px-3 py-1.5 text-xs font-medium text-theme-primary hover:opacity-80"
        onClick={() => acknowledgeDeployUpdateAndReload(pendingCommit)}
      >
        Reload
      </button>
    </div>
  );
};

export default DeployUpdatePrompt;
